function importAll(r) {
  r.keys().forEach(r);
}

// Import all images and icons.
importAll(require.context('./icons/', true));
importAll(require.context('./images/', true));

// Site styles. All other styles are entry points in webpack.config.js.
import './sass/standard.scss';

// Non-Vue JavaScript imports. Each should be a module that exports a default function.
import home from './modules/home/home';
import formBuilder from './modules/form_builder/_form_builder';

import 'svgxuse/svgxuse.js'; // Polyfill for SVG external referencing in IE9+.

import Vue from 'vue/dist/vue.js';
import ICS from 'vue-ics';
import VueCookies from 'vue-cookies/vue-cookies.js';
import ElementCms from './plugins/elementcms.js';
import Translator from './plugins/text-translator.js';

export const start = () => {
  const EventBus = {
    bus: new Vue()
  }

  EventBus.install = function() {
    Object.defineProperty(Vue.prototype, '$bus', {
      get() {
        return EventBus.bus;
      }
    });
  }

  Vue.use(ICS, { uidDomain: 'www.burnabyvillagemuseum.com', prodId: 'BVM'});
  Vue.use(EventBus);
  Vue.use(Translator);
  Vue.use(ElementCms);
  Vue.use(VueCookies);

  function appendGoogleRecaptchaScript() {
    if(document.body.classList.contains('recaptcha')) {
      const script = document.createElement('script');
      script.setAttribute('src', 'https://www.google.com/recaptcha/api.js');
      document.head.appendChild(script);
    }
  }

  const translateCookieName = 'translateBVM';

  Vue.config.productionTip = false;

  new Vue({
    el: '#app',
    mounted() {
      home();
      formBuilder();
      appendGoogleRecaptchaScript();
    },
    data() {
      return {
        isNavVisible: false,
        isSectionNavVisible: false,
        showPageControls: false,
      };
    },
    methods: {
      toggleNavVisibility() {
        this.isNavVisible = !this.isNavVisible;
        this.isSectionNavVisible = false;
      },
      toggleSectionNavVisibility() {
        this.isNavVisible = false;
        this.isSectionNavVisible = !this.isSectionNavVisible;
      },
      togglePageControls() {
        this.showPageControls = !this.showPageControls;
      },
      translate(language) {
        if(language) {
          this.$translator.translate(this.$el, language);
          this.$cookies.set(translateCookieName, language, null, '/', null, true, 'Strict');
        }
      },
    },
    components: {
      'sitemap': () => import(/* webpackChunkName: "sitemap" */ './modules/sitemap/sitemap.vue'),
      'sitemap-section': () => import(/* webpackChunkName: "sitemap" */ './modules/sitemap/sitemap_section.vue'),

      'faqs': () => import(/* webpackChunkName: "faqs" */ './modules/faqs/faqs.vue'),
      'photo-gallery': () => import(/* webpackChunkName: "photo_gallery" */ './modules/photo_gallery/photo_gallery.vue'),

      'tag-cloud': () => import(/* webpackChunkName: "tags" */ './modules/tags/tag_cloud.vue'),
      'tag-cloud-item': () => import(/* webpackChunkName: "tags" */ './modules/tags/tag_cloud_item.vue'),
      'tag-results': () => import(/* webpackChunkName: "tags" */ './modules/tags/tag_results.vue'),
      'tagged-pages': () => import(/* webpackChunkName: "tags" */ './modules/tags/tagged_pages.vue'),

      'spotlight': () => import(/* webpackChunkName: "spotlight" */ './modules/home/spotlight.vue'),
      'mini-schedule': () => import(/* webpackChunkName: "mini_schedule" */ './modules/home/mini_schedule.vue'),

      'interactive-map': () => import(/* webpackChunkName: "interactive_map" */ './modules/interactive_map/interactive_map.vue'),
      'instagram-gallery': () => import(/* webpackChunkName: "instagram_gallery" */ './modules/instagram_gallery/instagram_gallery.vue'),
      'instagram-preview': () => import(/* webpackChunkName: "instagram_gallery" */ './modules/instagram_gallery/instagram_preview.vue'),

      'program-sessions': () => import(/* webpackChunkName: "programs_schedule" */ './modules/programs_schedule/program_sessions.vue'),
      'programs-schedule': () => import(/* webpackChunkName: "programs_schedule" */ './modules/programs_schedule/programs_schedule.vue'),
      'activities-schedule': () => import(/* webpackChunkName: "activities_schedule" */ './modules/activities_schedule/activities_schedule.vue'),

      'site-search': () => import(/* webpackChunkName: "page_components" */ './components/site_search.vue'),
      'toggle-content': () => import(/* webpackChunkName: "page_components" */ './components/toggle_content.vue'),
      'main-nav': () => import(/* webpackChunkName: "page_components" */ './components/main_nav.vue'),
      'section-nav': () => import(/* webpackChunkName: "page_components" */ './components/section_nav.vue'),
      'notification-bar': () => import(/* webpackChunkName: "page_components" */ './components/notification_bar.vue'),
      'supplemental-layout-switch': () => import(/* webpackChunkName: "page_components" */ './components/supplemental_layout_switch.vue'),
      'text-resizer': () => import(/* webpackChunkName: "page_components" */ './components/text_resizer.vue'),
      'view-switcher': () => import(/* webpackChunkName: "page_components" */ './components/view_switcher.vue'),
      'translate-button': () => import(/* webpackChunkName: "page_components" */ './components/translate_button.vue'),
      'calendar-buttons': () => import(/* webpackChunkName: "page_components" */ './components/calendar_buttons.vue'),
      'weather-conditions': () => import(/* webpackChunkName: "page_components" */ './components/weather_conditions.vue'),
      'subscription-button': () => import(/* webpackChunkName: "page_components" */ './components/subscription_button.vue'),
    }
  });
}